import { Injectable, inject } from "@angular/core";
import { AppConfig } from "../../app-config";
import { ElasticFieldProps, ElasticIndexMetadata, SearchResponse } from "@pienso/ingest-types/elastic.interface";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { map, switchMap } from "rxjs/operators";

export enum ES_TYPE {
  TEXT = "text",
  KEYWORD = "keyword",
  LONG = "long",
  DOUBLE = "double",
  DATE = "date",
  BOOLEAN = "boolean",
}

export const columnTypeDisplayNames: { [type: string]: string } = {
  [ES_TYPE.TEXT]: "Text",
  [ES_TYPE.KEYWORD]: "Category",
  [ES_TYPE.LONG]: "Integer",
  [ES_TYPE.DOUBLE]: "Float",
  [ES_TYPE.DATE]: "Date",
  [ES_TYPE.BOOLEAN]: "Boolean",
};

@Injectable({ providedIn: "root" })
export class ElasticSearchService {
  private http = inject(HttpClient);
  private config = inject(AppConfig);

  private readonly endpoint;

  constructor() {
    const config = this.config;

    this.endpoint = config.ingestApiEndpoint + "/elastic/";
  }

  httpOptions(): { headers: HttpHeaders; observe: "body"; params?: HttpParams } {
    return {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      observe: "body",
    };
  }

  getIndexMetadata(index: string): Observable<ElasticIndexMetadata> {
    return this.http.get<ElasticIndexMetadata>(this.endpoint + "index/" + index, this.httpOptions());
  }

  getColumnProperties(index: string): Observable<ElasticFieldProps> {
    return this.getIndexMetadata(index).pipe(
      map((meta_response: ElasticIndexMetadata) => meta_response[index].mappings.properties),
    );
  }

  searchAll(esIndex: string, count?: number, offset?: number): Observable<SearchResponse<any>> {
    let params = new HttpParams();
    if (count) {
      params = params.set("count", "" + count);
    }
    if (offset) {
      params = params.set("offset", "" + offset);
    }
    const options = this.httpOptions();
    options.params = params;
    return this.http.get<SearchResponse<any>>(this.endpoint + "search/" + esIndex, options);
  }

  countAll(esIndex: string): Observable<number> {
    return this.searchAll(esIndex, 1, 0).pipe(switchMap((response) => of(response.hits.total.value)));
  }

  /** Used for e.g. find as you type */
  partialPhraseSearch(field: string, phrase: string, esIndex: string, count?: number, offset?: number) {
    let params = new HttpParams();
    params = params.set("field", field).set("phrase", phrase);
    if (count) {
      params = params.set("count", "" + count);
    }
    if (offset) {
      params = params.set("offset", "" + offset);
    }
    const options = this.httpOptions();
    options.params = params;
    return this.http.get<SearchResponse<any>>(this.endpoint + "searchPrefix/" + esIndex, options);
  }

  // async searchAll(esIndex: string, count?: number, offset?: number): Promise<SearchResponse<any>> {
  //   const params: SearchParams = {
  //     index: esIndex,
  //     body: {
  //       query: {
  //         match_all: {}
  //       },
  //       sort: [
  //         {'__rowNumber__': { order: 'asc' }}
  //       ]
  //     }
  //   };
  //   if (count) {
  //     params.size = count;
  //   }
  //   if (offset) {
  //     params.from = offset;
  //   }
  //   return this.client.search<any>(params);
  // }
  //
  // async getRows(esIndex: string, count?: number, offset?: number): Promise<any[]> {
  //   return this.searchAll(esIndex, count, offset)
  //   .then((sr: SearchResponse<any>) => sr.hits.hits.map(h => h._source));
  // }
}
